export enum BitumenModelTypes {
  SIMPLE = 'Simple',
  UTILITY = 'Utility',
}

export enum BitumenConversionYieldBasis {
  VOLUME = 'Volume',
  MASS = 'Mass',
}
